export default __webpack_public_path__ + "static/media/doll_l.bb575c73.svg";